import { AxiosClient } from './axios-client';
const PATH = 'agency';
export const ClientApi = {
  list: async () => {
    const result: any[] = await AxiosClient.get(PATH);
    return result;
  },
  getOne: async (id: any) => {
    const result: any = await AxiosClient.get(`${PATH}/${id}`);
    return result;
  },
  create: (name: string, pod_open: boolean, guam_open: boolean) => {
    return AxiosClient.post(PATH, { name, pod_open, guam_open });
  },
  update: (id: any, name: string) => {
    return AxiosClient.patch(`${PATH}/${id}`, { name });
  },
  destroy: (id: any) => {
    return AxiosClient.delete(`${PATH}/${id}`);
  },
};
